import React, { Fragment, useEffect, useState } from 'react'

// third party components
import { Dialog, Transition } from '@headlessui/react'
import { useViewport } from 'utils'

// custom components
import Alert from 'components/Alert'

// images and icons
import Lottie from 'lottie-react'
import ImageWithFoster from 'components/ImageWithFoster'
import LoadingIcon from 'assets/lottery/loader-black.json'

const ShopCanvas = 'https://foster-marketplace-dev.s3.us-east-2.amazonaws.com/shop-canvas.webp'
const ShopLuster = 'https://foster-marketplace-dev.s3.us-east-2.amazonaws.com/shop-luster.webp'
const ShopMetal = 'https://foster-marketplace-dev.s3.us-east-2.amazonaws.com/shop-metal.webp'
const ShopPoster = 'https://foster-marketplace-dev.s3.us-east-2.amazonaws.com/shop-paper-poster.webp'

// styles
import styles from './index.module.scss'

const SelectPrintModal = props => {
  const { open, close, onClick } = props
  const [showAlert, setShowAlert] = useState(false)
  const [alertData, setAlertData] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const viewport = useViewport()
  const [selectedPrint, setSelectedPrint] = useState('')

  const closeModal = () => {
    if (isLoading) return

    setSelectedPrint('')
    close()
  }
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className={styles.container} onClose={() => closeModal()}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={styles.bgView} />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-end sm:items-center justify-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-full sm:translate-y-0 sm:scale-95 overflow-hidden"
              enterTo="opacity-100 translate-y-0 sm:scale-100 overflow-hidden"
              leave="ease-in duration-200 overflow-hidden"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100 overflow-hidden"
              leaveTo="opacity-0 translate-y-full sm:translate-y-0 sm:scale-95 overflow-hidden"
            >
              <Dialog.Panel className={styles.modalView}>
                <div className={styles.topView}>Select your medium</div>
                <div className={styles.contentView}>
                  <div className="w-full h-auto flex flex-wrap sm:flex-nowrap justify-between items-center xl:gap-[10px] gap-[10px]">
                    <div
                      className={`${styles.printTypeView} ${selectedPrint === 'Paper' ? styles.selectedView : ''}`}
                      onClick={() => setSelectedPrint('Paper')}
                    >
                      <div className={styles.printArea}>
                        <ImageWithFoster src={ShopPoster} width={240} height={240} className="w-full h-full" />
                      </div>
                      <div className="w-full mt-[0px] sm:mt-[10px] mt-[15px]">
                        <div className={styles.title}>Matte Paper Poster</div>
                      </div>
                      <div className="w-full mt-[4px] sm:mt-[8px] mt-[10px]">
                        <div className={styles.desc}>Starting at $18.00</div>
                      </div>
                    </div>

                    <div
                      className={`${styles.printTypeView} ${selectedPrint === 'Canvas' ? styles.selectedView : ''}`}
                      onClick={() => setSelectedPrint('Canvas')}
                    >
                      <div className={styles.printArea}>
                        <ImageWithFoster src={ShopCanvas} width={240} height={240} className="w-full" />
                      </div>
                      <div className="w-full mt-[0px] sm:mt-[10px] mt-[15px]">
                        <div className={styles.title}>Canvas</div>
                      </div>
                      <div className="w-full mt-[4px] sm:mt-[8px] mt-[10px]">
                        <div className={styles.desc}>Starting at $26.00</div>
                      </div>
                    </div>

                    <div
                      className={`${styles.printTypeView} ${
                        selectedPrint === 'Glossy Metal Print' ? styles.selectedView : ''
                      }`}
                      onClick={() => setSelectedPrint('Glossy Metal Print')}
                    >
                      <div className={styles.printArea}>
                        <ImageWithFoster src={ShopMetal} width={240} height={240} className="w-full" />
                      </div>
                      <div className="w-full mt-[0px] sm:mt-[10px] mt-[15px]">
                        <div className={styles.title}>Glossy Metal Print</div>
                      </div>
                      <div className="w-full mt-[4px] sm:mt-[8px] mt-[10px]">
                        <div className={styles.desc}>Starting at $54.00</div>
                      </div>
                    </div>

                    <div
                      className={`${styles.printTypeView} ${
                        selectedPrint === 'Luster Photo Paper' ? styles.selectedView : ''
                      }`}
                      onClick={() => setSelectedPrint('Luster Photo Paper')}
                    >
                      <div className={styles.printArea}>
                        <ImageWithFoster src={ShopLuster} width={240} height={240} className="w-full" />
                      </div>
                      <div className="w-full mt-[0px] sm:mt-[10px] mt-[15px]">
                        <div className={styles.title}>Luster Photo Paper</div>
                      </div>
                      <div className="w-full mt-[4px] sm:mt-[8px] mt-[10px]">
                        <div className={styles.desc}>Starting at $19.00</div>
                      </div>
                    </div>
                  </div>
                  <div className="w-full flex justify-end sm:pr-[25px] lg:mt-[40px] mt-[35px] sm:mt-[30px]">
                    <div className="w-full sm:w-auto flex flex-col sm:flex-row gap-[15px]">
                      <div className={styles.cancelBtn} onClick={() => closeModal()}>
                        Cancel
                      </div>
                      <div
                        className={styles.continueBtn}
                        onClick={() => {
                          if (selectedPrint) {
                            onClick(selectedPrint)
                            setIsLoading(true)
                          } else {
                            setAlertData([
                              {
                                id: 0,
                                title: 'Select your medium',
                                description: `Please select your medium first to continue.`,
                                type: 'failure',
                              },
                            ])
                            setShowAlert(true)
                            setTimeout(() => {
                              setShowAlert(false)
                            }, 3000)
                          }
                        }}
                      >
                        {isLoading ? (
                          <div className={`flex items-center w-[40px]`}>
                            <Lottie animationData={LoadingIcon} loop={true} />
                          </div>
                        ) : (
                          <div>Continue</div>
                        )}
                      </div>
                    </div>
                  </div>
                  <Alert
                    open={showAlert}
                    close={() => {
                      setShowAlert(false)
                    }}
                    data={alertData}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default SelectPrintModal
